module.exports = __webpack_public_path__ + "img/logo.d3bd28ff.png";